/**
 * Build a comparator for `Array.sort` keyed on a single field of `T`.
 *
 * Null-handling: nulls sort to the end regardless of direction. The previous
 * "return 0 when either side is null" form violated total-order transitivity
 * (a==null vs dated b returns 0, b vs c dated-earlier returns -1, so a "==" b
 * and b < c but a wasn't ordered relative to c) and let V8 TimSort scatter
 * null rows through the dated ones — invisible until pagination clipped the
 * tail, then dated rows fell off the visible window.
 */
export function compareByField<T>(
  field: keyof T,
  desc: boolean
): (a: T, b: T) => number {
  return (a, b) => {
    const av = (a as Record<string, unknown>)[field as string]
    const bv = (b as Record<string, unknown>)[field as string]
    const aNull = av == null
    const bNull = bv == null
    if (aNull && bNull) return 0
    if (aNull) return 1
    if (bNull) return -1
    const cmp = av < bv ? -1 : av > bv ? 1 : 0
    return desc ? -cmp : cmp
  }
}
